import React from 'react'
import ReactLoading from 'react-loading'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'

import Notification from './Notification'

import { SUGGESTIONS_UPDATES } from 'constants'

import './styles.scss'

export default class Suggested extends BaseComponent {

  constructor() {
    super()

    this.state = {
      fetched: false,
      update_suggestions: []
    }

    this._bind('_getSuggested', '_renderNotification')
  }
  componentDidMount() {
    this._getSuggested()
  }

  _getSuggested() {
    request(SUGGESTIONS_UPDATES(1))
      .then(({update_suggestions}) => {
        this.setState({
          update_suggestions,
          fetched: true
        })
      })
  }

  _renderNotification(notification, index) {
    return (<Notification key={index} notification={notification} claimId={this.props.claimId} sms_enabled={this.props.sms_enabled}/>)
  }

  render() {
    return(
      <div id="SinisterSuggested" className="SinisterSuggested">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Notificaciones sugeridas"
          isToggle={true}
          open={false}
        >
          {
            !this.state.fetched ? (
              <ReactLoading id="Spin" type={'spin'} color={'#444'}  />
            ) : ( !!this.state.update_suggestions.length ? this.state.update_suggestions.map(this._renderNotification) : (
                  <p>No hay sugerencias</p>
                )
            )
          }
        </RetractablePanel>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Suggested/index.js